import { useStorage } from '@vueuse/core'
import genericLabel from './generic-label.xml?raw'
import qrLabel from './qr-label.xml?raw'
export const useDymo = () => {
  const printerIp = useStorage('printer_ip', 'localhost')
  const printLabel = async ({ type = 'generic', data }: { type?: string, data: any }) => {
    const printerName = 'DYMO LabelWriter 450 Turbo'
    const labelSetXml = ''
    let xmlToPrint = type === 'qr' ? qrLabel : genericLabel

    if (typeof process !== 'undefined' && process.env) {
      process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0' // TODO: Bundle the certificates.
    }

    Object.keys(data).forEach(xmlKey => {
      xmlToPrint = xmlToPrint.replace(new RegExp(`{${xmlKey}}`, 'g'), data[xmlKey])
    })

    xmlToPrint = xmlToPrint.replace(/ /g, ' ').trim()

    // await fetch(`https://${printerIp.value}:41951/DYMO/DLS/Printing/GetPrinters`)
    const label = `labelXml=${encodeURIComponent(xmlToPrint)}&printerName=${encodeURIComponent(printerName)}&printParamsXml=&labelSetXml`
    await fetch(`https://${printerIp.value}:41951/DYMO/DLS/Printing/PrintLabel`, {
      method: 'POST',
      body: label,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => response.text())
      .then(result => result)
      .catch(error => console.error(error))
  }

  return { printLabel }
}
